import React from 'react'
import classnames from 'classnames'
import './NotificationBubble.css'

const NotificationBubble = ({ count, active, showNotificationCount }) => {
    if (!count) return null

    return (
        <span
            className={classnames("NotificationBubble", { active, dot: !showNotificationCount })}
        >
            {showNotificationCount ? count : null}
        </span>
    )
}

export default NotificationBubble
